import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"button",class:_vm.styledClasses,style:(_vm.styles),attrs:{"disabled":(_vm.disabled || _vm.busy),"href":_vm.to},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }